import React from "react"
import ReactMarkdown from "react-markdown"

import { Button } from "../../anti/buttons/buttons"
import { Section, Container } from "../../anti/grid/grid"
import waCircle from "../../../assets/img/icons/wa-black.png"

export const AcfColHeadlineBlock = `
fragment AcfColHeadlineBlock on WordPress_AcfColHeadlineBlock {
    name
    attributes {
      className
    }
    colHeadline {
      bgColor
      title
      text
      additionalInfo {
        label
        value
      }
      buttons {
        text
        link {
          target
          url
        }
      }
      list {
        text
        icon {
          sourceUrl
        }
      }
    }
  }
`

export const AcfColHeadline = ({ data }) => {
  const colHeadline = data.colHeadline
  const isMarketingGallery =
    data.colHeadline.title ===
    "Visit our Marketing gallery to learn more about BSD City and its facilities"
  return (
    <Section
      className={`${colHeadline.bgColor || ""} ${data.attributes.className ||
        ""}`}
    >
      <Container>
        <div className="row">
          <div className="col-lg-5 col-xl-6">
            <h2 className="h2">{colHeadline.title}</h2>
          </div>
          <div className="col-lg-7 col-xl-6">
            <ReactMarkdown source={colHeadline.text} escapeHtml={false} />
            {colHeadline.list &&
              colHeadline.list.length > 0 &&
              !undefined &&
              colHeadline.list.map((item, i) => {
                const isPhoneNumber = item.text?.includes?.("(021)")
                const isWaNumber = item.text?.includes?.("8811382862")
                if (isPhoneNumber) {
                  return (
                    <div key={i} className="mb-3">
                      <a
                        href={`tel:+6221-50368368`}
                        className="icon-text"
                        target="_blank"
                      >
                        <img src={item.icon.sourceUrl} />
                        <p style={{ flex: 1, color: "#333", marginLeft: 16 }}>
                          {item.text}
                        </p>
                      </a>
                    </div>
                  )
                }
                if (isWaNumber) {
                  return null
                }
                return (
                  <div key={i} className="icon-text">
                    <img src={item.icon.sourceUrl} />
                    <p>
                      <ReactMarkdown source={item.text} escapeHtml={false} />
                    </p>
                  </div>
                )
              })}
            {isMarketingGallery && (
              <div className="">
                <a
                  href="https://api.whatsapp.com/send/?phone=628811382862&text=Hi%2C%20saya%20ingin%20info%20dan%20berkonsultasi%20untuk%20produk%20di%20BSD%20City%0A%0ASaya%20dengan%3A%20%0A%0ATerima%20kasih!%20%0A%0ABSDWebsite%2C%20LSN%3A%20Digital-Marcomm-Development-05082025-BSD-Website"
                  className="icon-text"
                  target="_blank"
                >
                  <img className="circle" src={waCircle} />
                  <p style={{ flex: 1, color: "#333", marginLeft: 16 }}>
                    +62 8811382862
                  </p>
                </a>
              </div>
            )}
            {colHeadline.buttons &&
              colHeadline.buttons.map((button, i) => {
                return (
                  <Button
                    variant="secondary"
                    className="btn-block-down-md mt-4"
                    link={button.link && button.link.url}
                    key={`${i}`}
                  >
                    {button.text} <i className="fas fa-arrow-right ml-1"></i>
                  </Button>
                )
              })}
          </div>
        </div>
      </Container>
    </Section>
  )
}
